import React from "react";
import { FilterSection, ActiveFilterPills } from "../../components/UserProfiles";
import {
  useBoostHistory,
  BoostHistoryTable,
} from "../../components/BoostHistory";
import PaginationBar from "../../components/common/PaginationBar";

const BOOST_PILL_CLASSES = {
  action: "bg-red-100 text-red-800",
  user_id: "bg-purple-100 text-purple-800",
  search: "bg-yellow-100 text-yellow-800",
  start_date: "bg-blue-100 text-blue-800",
  end_date: "bg-green-100 text-green-800",
};

function getBoostPillClassName(key) {
  return BOOST_PILL_CLASSES[key] || "bg-gray-100 text-gray-800";
}

export default function BoostHistory() {
  const {
    historyFilters,
    handleFilterChange,
    clearFilters,
    removeFilter,
    getFilterLabel,
    getActiveFiltersCount,
    activeFilterEntries,
    primaryFields,
    boostHistory,
    currentPage,
    setCurrentPage,
    totalPages,
    totalItems,
    loadingHistory,
    historyError,
    limit,
    fetchBoostHistory,
  } = useBoostHistory();

  return (
    <div className="p-4 w-full">
      <div className="bg-white rounded-xl shadow-xl p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 mb-3">
          <h2 className="text-md md:text-2xl font-bold text-gray-800">
            Boost History
          </h2>
          {getActiveFiltersCount() > 0 && (
            <button
              type="button"
              onClick={clearFilters}
              className="text-xs sm:text-sm text-red-600 hover:text-red-700 font-medium self-start sm:self-center">
              Clear All Filters
            </button>
          )}
        </div>

        <ActiveFilterPills
          activeKeys={activeFilterEntries}
          filters={historyFilters}
          getLabel={getFilterLabel}
          onRemove={removeFilter}
          label="Active Filters:"
          getPillClassName={getBoostPillClassName}
        />

        <FilterSection
          primaryFields={primaryFields}
          secondaryFields={[]}
          values={historyFilters}
          onChange={(e) => handleFilterChange(e.target.name, e.target.value)}
          onApply={() => setCurrentPage(1)}
          onClear={clearFilters}
          applyLabel="Apply"
          clearLabel="Clear All"
        />

        <BoostHistoryTable
          items={boostHistory}
          isLoading={loadingHistory}
          error={historyError}
          onRetry={() => fetchBoostHistory(currentPage, historyFilters)}
        />

        <PaginationBar
          page={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          pageSize={limit}
          label="boost history"
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
}
